import {DataObject} from "./dataObject";
import TimeStamp from "../timeStamp";
import store from "../../store/store";
import {db} from "../db";
import SpielService from "./spielService";

export class Saison extends DataObject {
    constructor(){
        super();
        this.id = '';
        this.ligaId = '';
        this.lvId = '';
        this.sportJahr = '';
        this.anzahlSpieler = null;
        this.anzahlErsatzSpieler = null;
        this.eintauschVorEinspielzeit = false;
        this.freieSpieler = false;
        this.tabellenFarben = {};
        this.teams = {}; // id with object: name, vereinsId, vereinsName
        this.spiele = {}; // id with object: spiel
        this.spielfrei = {}; // { 1F: { t1: true, t5: true } }
        this.isCup = false;
        this.local.definitions.databaseHandlerCall = 'saison';
        this.local.teamsTemp = {};
        this.local.tabelle = [];
        this.local.tabelleEmpty = [];
        this.local.spielerTemp = {};
        this.local.schnittliste = [];
        this.local.spieleSchnittliste = { H: null, F: null};
        this.local.showByTeam = false;
        this.local.roundFrom = null;
        this.local.roundUntil = null;
        //https://stackoverflow.com/questions/2784230/how-do-you-sort-an-array-on-multiple-columns
        /*this.local.sortFirstBy = (function(){function e(f){f.thenBy=t;return f}
        function t(y,x){x=this;return e(function(a,b){return x(a,b)||y(a,b)})}return e})();*/
    }

// override default methods
    setFromDataObject(dataObject){
        super.setFromDataObject(dataObject);
        this.setLocalTeamsTemp();
        this.calculateTabelle();
        /*this.calculateSchnittlisten();*/
    }
// getter
    getCountOfTabPosColors(){ return Object.keys(this.tabellenFarben).length }
    /*getTabellenPosList(){
        let list=[];
        for ( let i = 1; i <= Object.keys(this.teams).length; i++ ) {
            list.push(i);
        }
        return list;
    }*/
    getTabPosColorList(){
        let list = [];
        Object.keys(this.tabellenFarben).forEach( (id) => {
            list.push({color: this.tabellenFarben[id], tabPos: id })
        });
        return list;
    }
    getRegion(){
        const lv = store.state.realtime.landesverbaende[this.lvId];
        return lv.name.replace('LV - ', '').replace(' Kegeln', '');
    }
    getLigaFullName(){
        const lv = store.state.realtime.landesverbaende[this.lvId];
        return lv.ligen[this.ligaId].nameFull;
    }
    getSpielfreieTeamsForRunde(rundeText){
        const rundeTextTemp = rundeText.split('_');
        const rundeTextKorr = rundeTextTemp[0].substr(6).replace(' ', '_');
        const runde = this.spielfrei[rundeTextKorr];
        const list = [];
        Object.keys(runde).forEach( (teamId) => {
            if ( this.teams[teamId] ) {
                let team = this.teams[teamId];
                team.id = teamId;
                list.push(this.teams[teamId]);
            }
        });
        return list;
    }
    getLiveGames(liga){
        let liveGames = [];
        Object.keys(this.spiele).forEach( (spielId) => {
            let spiel = this.spiele[spielId];
            if ( SpielService.isLiveGame(spiel) ) {
                spiel.id = spielId;
                spiel.liga = liga ? liga : this.local.title;
                spiel = this.getSpielForTable(spiel);
                liveGames.push(spiel);
            }
        });
        return liveGames;
    }
// setter
    deleteTabPosColor(tabPos){
        delete this.tabellenFarben[tabPos];
    }
// team name or vereins changes
    teamIsNotDeleteable( teamId){
        let result = false;
        Object.keys(this.spiele).forEach( (spielId) => {
            if ( this.spiele[spielId].gast.teamId === teamId ) { result = true; }
            if ( this.spiele[spielId].heim.teamId === teamId ) { result = true; }
        });
        return result;
    }
    teamHasAlreadyPlayed(teamId){
        let result = false;
        Object.keys(this.spiele).forEach( (spielId) => {
            if ( this.hasPlayed(this.spiele[spielId], teamId, 'heim') === true ) { result = true; }
            if ( this.hasPlayed(this.spiele[spielId], teamId, 'gast') === true ) { result = true; }
        });
        return result;
    }
        hasPlayed(spiel, teamId, type){
            if ( spiel[type].teamId === teamId ) {
                if ((spiel.vereine[type] !== '' &&
                    spiel.vereine[type].indexOf('pending') === -1 ) ||
                    spiel.referee.name) {
                    return true
                }
            }
            return false;
        }
    updateTeamData(teamId, vereinsNr){
        let promiseList = [];
        Object.keys(this.spiele).forEach( (spielId) => {
            const spiel = this.spiele[spielId];
            if ( spiel.gast.teamId === teamId && !this.hasPlayed(spiel, vereinsNr, 'gast')) {
                promiseList.push(this.getUpdatePromiseForSpiel(teamId, spielId, 'gast'));
            }
            if ( spiel.heim.teamId === teamId && !this.hasPlayed(spiel, vereinsNr, 'heim')) {
                promiseList.push(this.getUpdatePromiseForSpiel(teamId, spielId, 'heim'));
            }
        });
        this.processUpdates(promiseList);
    }
        getUpdatePromiseForSpiel(teamId, spielId, teamType){
            const teamName = teamType + '.teamName';
            const vereinsName = teamType + '.vereinsName';
            const vereinsNr = teamType + '.vereinsNr';
            const updateObject = {
                [teamName]: this.teams[teamId].name,
                [vereinsName]: this.teams[teamId].vereinsName,
                [vereinsNr]: this.teams[teamId].lvId + this.teams[teamId].vereinsNr,
            };
            const promise = new Promise( (resolve) => {
                db.collection('spiele').doc(spielId)
                    .update( updateObject )
                    .then(() => {
                        console.log("Document successfully updated!");
                        resolve('done');
                    })
                    .catch((error) => {
                        console.error("Error updating document: ", error);
                        resolve('done');
                    });
            });
            return promise;
        }
        processUpdates(promiseList){
            return new Promise( (resolve) => {
                Promise.all(promiseList).then( () => {
                    store.state.local.loader = false;
                    window.history.back();
                    resolve('done');
                });
            })
        }
// spiel relevant for tabelle or schnittliste
    countSpielResults(spiel){
        return spiel.vereine.heim.indexOf('created') !== -1 || spiel.vereine.heim.indexOf('confirmed') !== -1
    }

// tabelle
    setLocalTeamsTemp(){
        this.local.teamsTemp = JSON.parse(JSON.stringify(this.teams)) ;
        Object.keys(this.local.teamsTemp).forEach( (teamId) => {
            this.local.teamsTemp[teamId].tabPkt = this.getStartPoints(teamId, 'tabPkt');
            this.local.teamsTemp[teamId].pos = null;
            this.local.teamsTemp[teamId].posFormat = 0;
            this.local.teamsTemp[teamId].spiele = this.getStartPoints(teamId, 'spiele');
            this.local.teamsTemp[teamId].siege = this.getStartPoints(teamId, 'siege');
            this.local.teamsTemp[teamId].niederlagen = this.getStartPoints(teamId, 'niederlagen');
            this.local.teamsTemp[teamId].unentschieden = this.getStartPoints(teamId, 'unentschieden');
            this.local.teamsTemp[teamId].satzpunkteS = this.getStartPoints(teamId, 'satzpunkteS');
            this.local.teamsTemp[teamId].satzpunkteN = this.getStartPoints(teamId, 'satzpunkteN');
            this.local.teamsTemp[teamId].satzpunkte = '';
            this.local.teamsTemp[teamId].satzpunkteDiff = 0;
            this.local.teamsTemp[teamId].mannschaftsPunkteS = this.getStartPoints(teamId, 'mannschaftsPunkteS');
            this.local.teamsTemp[teamId].mannschaftsPunkteN =  this.getStartPoints(teamId, 'mannschaftsPunkteN');
            this.local.teamsTemp[teamId].mannschaftsPunkte = 0;
            this.local.teamsTemp[teamId].mannschaftsPunkteDiff = 0;
        });
    }
        getStartPoints(teamId, field){
            return this.teams[teamId][field] ? this.teams[teamId][field] : 0;
        }
    calculateTabelle(){
        this.writeResultsToTeamsTemp();
        this.createArrayFromTeamsTemp();
        this.calculateResultValues();
        this.sortTabelleAndWritePosition();
        this.local.tabelle = this.local.tabelle.concat(this.local.tabelleEmpty);
    }
        writeResultsToTeamsTemp(){
            Object.keys(this.spiele).forEach( (spielId) => {
                const spiel = this.spiele[spielId];
                if ( this.countSpielResults(spiel) ) {
                    this.setTabellenParameter(spiel, 'heim');
                    this.setTabellenParameter(spiel, 'gast');
                }
            });
        }
            setTabellenParameter(spiel, type){
                let teamTemp = this.local.teamsTemp[spiel[type].teamId];
                let opponentType = type === 'heim' ? 'gast' : 'heim';
                let result = spiel[type].result;
                let opponentResult = spiel[opponentType].result;
                teamTemp.tabPkt += result.tabPkt;
                teamTemp.satzpunkteS += result.sp;
                teamTemp.satzpunkteN += opponentResult.sp;
                teamTemp.mannschaftsPunkteS += result.mp;
                teamTemp.mannschaftsPunkteN += opponentResult.mp;
                teamTemp.spiele++;
                teamTemp.siege += result.tabPkt === 2 ? 1 : 0;
                teamTemp.unentschieden += result.tabPkt === 1 ? 1 : 0;
                teamTemp.niederlagen += result.tabPkt === 0 ? 1 : 0;
            }
        createArrayFromTeamsTemp(){
            const teamsTemp = this.local.teamsTemp;
            Object.keys(teamsTemp).forEach( (teamTemp) => {
                if ( teamsTemp[teamTemp].spiele > 0 ) {
                    this.local.tabelle.push(teamsTemp[teamTemp])
                } else {
                    this.local.tabelleEmpty.push(teamsTemp[teamTemp])
                }
            });
        }
        calculateResultValues(){
            this.local.tabelle.forEach( (team) => {
                team.satzpunkte = team.satzpunkteS + ":" + team.satzpunkteN;
                team.satzpunkteDiff = team.satzpunkteS - team.satzpunkteN;
                team.mannschaftsPunkte = team.mannschaftsPunkteS + ":" + team.mannschaftsPunkteN;
                team.mannschaftsPunkteDiff = team.mannschaftsPunkteS - team.mannschaftsPunkteN;
            });
        }
            getFormatted(value){
                let text = '000' + value.tabPkt;
                return text.substr(text.length - 3, 3)
            }
        sortTabelleAndWritePosition(){
            let tabelle = this.local.tabelle;
            tabelle.sort((b, a) => a.tabPkt > b.tabPkt ? 1 :
                                    (a.tabPkt === b.tabPkt ?
                                    (a.mannschaftsPunkteDiff > b.mannschaftsPunkteDiff ? 1 :
                                    (a.mannschaftsPunkteDiff === b.mannschaftsPunkteDiff ?
                                    (a.satzpunkteDiff > b.satzpunkteDiff ? 1 : -1) : -1) ) : -1) );
                /*.sort(
                    this.local.sortFirstBy ((b, a) => a.tabPkt > b.tabPkt ? 1 : -1)
                        .thenBy((b, a) => a.mannschaftsPunkteDiff > b.mannschaftsPunkteDiff ? 1 : -1)
                        .thenBy((b, a) => a.satzpunkteDiff > b.satzpunkteDiff ? 1 : -1)
                );*/ //https://stackoverflow.com/questions/2784230/how-do-you-sort-an-array-on-multiple-columns
            // MEMO direkter Vergleich missing!!!
            // Beim Durchlaufen vergleichen, falls alles gleich ist
            for ( let i = 0; i < tabelle.length; i++ ) {
                if ( i > 0 &&
                    tabelle[i].tabPkt === tabelle[i-1].tabPkt &&
                    tabelle[i].mannschaftsPunkteDiff === tabelle[i-1].mannschaftsPunkteDiff &&
                    tabelle[i].satzpunkteDiff === tabelle[i-1].satzpunkteDiff &&
                    tabelle[i].spiele
                ) {
                    tabelle[i].pos = '';
                } else if ( tabelle[i].spiele === 0 ) {
                    tabelle[i].pos = '';
                } else {
                    tabelle[i].pos = i+1;
                }
                if ( tabelle[i].spiele > 0 ) {
                    tabelle[i].posFormat = i+1;
                }
            }
        }
// schnittlisten
    getSchnittlistenPos(searchSpieler, location, timeFrame) {
        const schnittKey = location + 'Schnitt' + timeFrame;
        const spieleKey = location + 'Spiele' + timeFrame;
        let liste = JSON.parse(JSON.stringify(this.local.schnittliste));
        liste.sort((b, a) => parseFloat(a[schnittKey]) > parseFloat(b[schnittKey]) ? 1 :
                             (parseFloat(a[schnittKey]) === parseFloat(b[schnittKey]) ?
                             (a[spieleKey] > b[spieleKey] ? 1 : -1) : -1) );
    // ex aequo Korrektur
        let schnitt = 0;
        let posKorr = 0;
        for ( let i = 0; i < liste.length; i++ ) {
            if ( schnitt !== liste[i][schnittKey]) {
                posKorr = i + 1;
                schnitt = liste[i][schnittKey];
            }
            liste[i].posKorr = posKorr;
        }
    // return
        let pos = this.local.showByTeam ?
            liste.findIndex(spieler => spieler.passNr === searchSpieler.passNr &&
                                       spieler.team === searchSpieler.team) :
            liste.findIndex(spieler => spieler.passNr === searchSpieler.passNr );
        return liste[pos].posKorr;
    }
    // calculation
    calculateSchnittlisten(schnittlisteHRaw, schnittlisteFRaw, showByTeam, roundFrom, roundUntil){
        this.local.showByTeam = showByTeam;
        this.local.roundFrom = parseInt(roundFrom);
        this.local.roundUntil = parseInt(roundUntil);
        this.local.schnittliste = [];
        this.local.spieleSchnittliste = {H: schnittlisteHRaw, F: schnittlisteFRaw};
        this.local.spielerTemp = {};
        if ( schnittlisteHRaw && Object.keys(schnittlisteHRaw.spiele).length > 0 ) {
            /*console.log ("H schnittListe", JSON.parse(JSON.stringify(this.local.schnittListe)) );
            console.log ("H spieleSchnittliste", JSON.parse(JSON.stringify(this.local.spieleSchnittliste)) );
            console.log ("H spielerTemp", JSON.parse(JSON.stringify(this.local.spielerTemp)) );*/
            this.setLocalSpielerTemp(schnittlisteHRaw, 'H'); }
        if ( schnittlisteFRaw && Object.keys(schnittlisteFRaw.spiele).length > 0 ) {
            this.setLocalSpielerTemp(schnittlisteFRaw, 'F'); }
        this.writeToSchnittliste();
    }
    setLocalSpielerTemp(schnittlisteRaw, semester){
        Object.keys(schnittlisteRaw.spiele).forEach( (spielId) => {
            const spiel = schnittlisteRaw.spiele[spielId];
            if ( this.showRound(spiel) ) {
                this.processSpielerPerType(spielId, 'gast', spiel.gast.spieler,
                    spiel.gast.vereinsNr + ' / ' + spiel.gast.vereinsName,
                    spiel.gast.teamName ? spiel.gast.vereinsNr + ' / ' + spiel.gast.teamName : null,
                    semester );
                this.processSpielerPerType(spielId, 'heim', spiel.heim.spieler,
                    spiel.heim.vereinsNr + ' / ' + spiel.heim.vereinsName,
                    spiel.heim.teamName ? spiel.heim.vereinsNr + ' / ' + spiel.heim.teamName : null,
                    semester );
            }
        });
    }
        showRound(spiel){
            const roundFrom = this.local.roundFrom;
            const roundUntil = this.local.roundUntil;
            if ( roundFrom && roundUntil) {
                if ( roundFrom > roundUntil ) {
                    return parseInt(spiel.runde) >= roundUntil &&
                        parseInt(spiel.runde) <= roundFrom
                } else {
                    return parseInt(spiel.runde) >= roundFrom &&
                           parseInt(spiel.runde) <= roundUntil
                }
            } else if ( roundFrom ) {
                return parseInt(spiel.runde) >= roundFrom
            } else if ( roundUntil) {
                return parseInt(spiel.runde) <= roundUntil
            } else {
                return true;
            }
        }
        processSpielerPerType(spielId, type, spielerObjectOrig, vereinsName, teamName, semesterKey){
            const spielerObject = JSON.parse(JSON.stringify(spielerObjectOrig));
            Object.keys(spielerObject).forEach( (spielerId) => {
                this.setSpielerParameter(spielId, spielerId, spielerObject[spielerId],
                                         vereinsName, teamName, type, semesterKey)
            });
        }
    /*setLocalSpielerTemp(schnittlisteRaw){
        console.log ("schnittlisteRaw", schnittlisteRaw);
        Object.keys(this.schnittlisteRaw.spiele).forEach( (spielId) => {
            if ( this.countSpielResults(this.spiele[spielId]) ) {
                let team = null;
                Object.keys(this.spiele[spielId].partien).forEach( (partieId) => {
                    const semesterKey = this.spiele[spielId].saison.semester;
                    team = this.spiele[spielId].partien[partieId].heim;
                    if ( team.spieler.id ) {
                        this.setSpielerParameter(this.spiele[spielId], team, 'heim', semesterKey);
                    }
                    team = this.spiele[spielId].partien[partieId].gast;
                    if ( team.spieler.id ) {
                        this.setSpielerParameter(this.spiele[spielId], team, 'gast', semesterKey);
                    }
                });
            }
        });
    }*/
        setSpielerParameter(spielId, spielerId, spieler, vereinsName, teamName, type, semesterKey) {
            const spieleKey = type + 'Spiele' + semesterKey;
            const schnittKey = type + 'Kegel' + semesterKey;
            const spieleKeyT = type + 'SpieleT';
            const schnittKeyT = type + 'KegelT';
            /*let localSpielerTemp = this.getLocalSpielerTemp(spielId, spielerId, spieler, vereinsName);
            localSpielerTemp[spielerId][schnittKey] += spieler.kegel;
            localSpielerTemp[spielerId][spieleKey]++;
            localSpielerTemp[spielerId][schnittKeyT] += spieler.kegel;
            localSpielerTemp[spielerId][spieleKeyT]++;
        //handle spieler name changes during season
            if ( localSpielerTemp[spielerId].name !== spieler.name &&
                localSpielerTemp[spielerId].lastPlayed <
                this.spiele[spielId].infos.datum + this.spiele[spielId].infos.uhrzeit) {
                localSpielerTemp[spielerId].name = spieler.name;
                localSpielerTemp[spielerId].lastPlayed = this.spiele[spielId].infos.datum +
                    this.spiele[spielId].infos.uhrzeit;
            }*/
            if ( this.local.showByTeam && !teamName ) { return; }
            const spielerTempId = this.local.showByTeam ?
                                    spielerId + spieler.name.substr(0,6) + teamName :
                                    spielerId + spieler.name.substr(0,6);
            if ( !this.local.spielerTemp[spielerTempId] ) {
                this.local.spielerTemp[spielerTempId] = this.newSpieler(spielId, spielerTempId,
                                                                    spieler, vereinsName, teamName);
            }
            this.local.spielerTemp[spielerTempId][schnittKey] += spieler.kegel;
            this.local.spielerTemp[spielerTempId][spieleKey]++;
            this.local.spielerTemp[spielerTempId][schnittKeyT] += spieler.kegel;
            this.local.spielerTemp[spielerTempId][spieleKeyT]++;
        //handle spieler name changes during season
            if ( this.local.spielerTemp[spielerTempId].name !== spieler.name &&
                this.local.spielerTemp[spielerTempId].lastPlayed <
                this.spiele[spielId].infos.datum + this.spiele[spielId].infos.uhrzeit) {
                this.local.spielerTemp[spielerTempId].name = spieler.name;
                this.local.spielerTemp[spielerTempId].lastPlayed = this.spiele[spielId].infos.datum +
                                                                this.spiele[spielId].infos.uhrzeit;
            }
        }
        /*getLocalSpielerTemp(spielId, spielerId, spieler, vereinsName){
            if ( !this.local.spielerTemp[spielerId] ) {
                this.local.spielerTemp[spielerId] = this.newSpieler(spielId, spielerId,
                    spieler, vereinsName);
            } else if ( this.local.spielerTemp[spielerId].name.substr(0,6) !== spieler.name.substr(0,6) ) {

            }
        }*/
        newSpieler(spielId, spielerId, spieler, vereinsName, teamName){
            return {
                pos: 0,
                id: spielerId,
                name: spieler.name,
                passNr: spieler.name.substr(0,6),
                nationalitaet: spieler.land,
                akHJ: spieler.akHJ,
                akJahr: spieler.akJahr,
                verein: vereinsName,
                team: teamName,
                lastPlayed: this.spiele[spielId].infos.datum + this.spiele[spielId].infos.uhrzeit, //required to check and handle spieler name changes
                heimSpieleH: 0,
                gastSpieleH: 0,
                totalSpieleH: 0,
                heimKegelH: 0,
                gastKegelH: 0,
                totalKegelH: 0,
                heimSpieleF: 0,
                gastSpieleF: 0,
                totalSpieleF: 0,
                heimKegelF: 0,
                gastKegelF: 0,
                totalKegelF: 0,
                heimSpieleT: 0,
                gastSpieleT: 0,
                totalSpieleT: 0,
                heimKegelT: 0,
                gastKegelT: 0,
                totalKegelT: 0,
            }
        }
    writeToSchnittliste(){
        Object.keys(this.local.spielerTemp).forEach( (spielerTempId) => {
            const spielerTemp = this.local.spielerTemp[spielerTempId];
            let spieler = {
                id: spielerTempId.substr(0,20),
                passNr: spielerTemp.passNr,
                name: spielerTemp.name.substr(9),
                akHJ: spielerTemp.akHJ,
                akJahr: spielerTemp.akJahr,
                verein: spielerTemp.verein,
                team: spielerTemp.team,
                nationalitaet: spielerTemp.nationalitaet,
            // HERBST
                heimSpieleH: spielerTemp.heimSpieleH,
                gastSpieleH: spielerTemp.gastSpieleH,
                totalSpieleH: spielerTemp.heimSpieleH + spielerTemp.gastSpieleH,
                heimSchnittH: spielerTemp.heimKegelH ?
                            ( spielerTemp.heimKegelH / spielerTemp.heimSpieleH ).toFixed(2) : '0.00',
                gastSchnittH:  spielerTemp.gastKegelH ?
                            ( spielerTemp.gastKegelH / spielerTemp.gastSpieleH ).toFixed(2) : '0.00',
                totalSchnittH: (spielerTemp.heimKegelH + spielerTemp.gastKegelH) > 0 ? (
                    ( spielerTemp.heimKegelH + spielerTemp.gastKegelH ) /
                    ( spielerTemp.heimSpieleH + spielerTemp.gastSpieleH) ).toFixed(2) : '0.00',
            // FRÜHJAHR
                heimSpieleF: spielerTemp.heimSpieleF,
                gastSpieleF: spielerTemp.gastSpieleF,
                totalSpieleF: spielerTemp.heimSpieleF + spielerTemp.gastSpieleF,
                heimSchnittF: spielerTemp.heimKegelF ?
                            ( spielerTemp.heimKegelF / spielerTemp.heimSpieleF ).toFixed(2) : '0.00',
                gastSchnittF: spielerTemp.gastKegelF ?
                            ( spielerTemp.gastKegelF / spielerTemp.gastSpieleF ).toFixed(2) : '0.00',
                totalSchnittF: (spielerTemp.heimKegelF + spielerTemp.gastKegelF) > 0 ? (
                        ( spielerTemp.heimKegelF + spielerTemp.gastKegelF ) /
                        ( spielerTemp.heimSpieleF + spielerTemp.gastSpieleF) ).toFixed(2) : '0.00',
            // TOTAL
                heimSpieleT: spielerTemp.heimSpieleT,
                gastSpieleT: spielerTemp.gastSpieleT,
                totalSpieleT: spielerTemp.heimSpieleT + spielerTemp.gastSpieleT,
                heimSchnittT: spielerTemp.heimKegelT ?
                            ( spielerTemp.heimKegelT / spielerTemp.heimSpieleT ).toFixed(2) : '0.00',
                gastSchnittT:  spielerTemp.gastKegelT ?
                            ( spielerTemp.gastKegelT / spielerTemp.gastSpieleT ).toFixed(2) : '0.00',
                totalSchnittT: (spielerTemp.heimKegelT + spielerTemp.gastKegelT) > 0 ? (
                    ( spielerTemp.heimKegelT + spielerTemp.gastKegelT ) /
                    ( spielerTemp.heimSpieleT + spielerTemp.gastSpieleT) ).toFixed(2) : '0.00',
            };
            this.local.schnittliste.push(spieler);
        });
    }
// teams
    isTeamNameDuplicate(name) {
        let check = false;
        Object.keys(this.teams).forEach( (teamId) => {
            if ( this.teams[teamId].name === name ) {
                check = true;
            }
        });
        return check;
    }

    getNextTeamId(){
        let newId = 1;
        Object.keys(this.teams).forEach( (teamId) => {
            if ( parseInt(teamId) >= newId ) { newId = parseInt(teamId) + 1 }
        });
        return newId;
    }

    getSortedTeamList(){
        let list = [];
        Object.keys(this.teams).forEach( (teamId) => {
            let team = this.teams[teamId];
            team.id = teamId;
            list.push(team)          ;
        });
        list.sort((a, b) => a.name > b.name ? 1 : -1);
        return list;
    }

    getSpielPlanList(semester, spielStatus){
        let list = [];
        Object.keys(this.spiele).forEach( (spieleId) => {
            let spiel = this.spiele[spieleId];
            let played = spiel.heim.result.kegel > 0 || spiel.gast.result.kegel > 0 ||
                spiel.infos.stream || spiel.vereine.gast.indexOf('adminVerified') !== -1 ;
            if ( (semester === spiel.saison.semester || semester === 'A') &&
                ( (played && spielStatus === 'played') || (!played && spielStatus !== 'played'))
            ) {
                spiel.id = spieleId;
                //spiel.rundeGroup = spiel.saison.runde + ' ' + spiel.saison.semester;
                spiel = this.getSpielForTable(spiel);
                list.push(spiel);
            }
        });
        list.sort((a, b) => a.rundeGroup > b.rundeGroup ? 1 : -1);
        return list;
    }
        getSpielForTable(spiel){
            const dateTimeStr = TimeStamp.getStringDotDateFromString(spiel.infos.datum)  + ", " + spiel.infos.uhrzeit
            const ts = TimeStamp.getGMTTimestamp();
            spiel.rundeGroup = spiel.saison.isCup && spiel.saison.rundeText ?
                    this.leadingZeroForSort(spiel.saison.semester, spiel.saison.runde) + '_' + spiel.saison.rundeText :
                    this.leadingZeroForSort(spiel.saison.semester, spiel.saison.runde)
            //spiel.saison.semester === 'H' ? 1 : 2 + spiel.saison.runde / 100;
            spiel.runde = spiel.saison.runde + ' ' + spiel.saison.semester;
            spiel.vs = ':';
            spiel.heimTeam = spiel.heim.teamName;
            spiel.gastTeam = spiel.gast.teamName;
            spiel.heimCupLeader = spiel.heim.result.cupLeader
            spiel.gastCupLeader = spiel.gast.result.cupLeader
            //const ort = spiel.infos.ort ? ", " + spiel.infos.ort : '';
            spiel.termin = spiel.infos.wochentag + ". " + dateTimeStr;
            spiel.details = spiel.termin + spiel.infos.ort + ', ' + spiel.infos.bahn;
            spiel.saison.id = this.id;
            spiel.tabPktResult = spiel.heim.result.tabPkt + ':' + spiel.gast.result.tabPkt;
            spiel.spResult = spiel.heim.result.sp + ':' + spiel.gast.result.sp;
            spiel.mpResult = spiel.heim.result.mp + ':' + spiel.gast.result.mp;
            spiel.fwResult = spiel.heim.result.fw + ' : ' + spiel.gast.result.fw;
            spiel.arResult = spiel.heim.result.ar + ' : ' + spiel.gast.result.ar;
            spiel.kegelResult = spiel.heim.result.kegel + ' : ' + spiel.gast.result.kegel;
            spiel.statusText = SpielService.getSpielStatusText(spiel).text;
            spiel.info = spiel.vereine.confirmedHeim > ts - 3*24*60*60*1000 ? dateTimeStr + ' - neu' : dateTimeStr;
            return spiel;
        }

        leadingZeroForSort(semester, runde){
            const pad = "00000";
            let n = ( (semester === 'H' ? 1 : 2) + runde / 100 ).toString();
            if ( n.length < 4 ) {
                n = n + '0'
            } else if ( n.length > 4 ) {
                n = n.substr(0,4)
            }
            return (pad+n).slice(-pad.length) + '/' + runde + ' ' + semester;
        }
// MASS CHANGED
    isAnzahlErsatzspielerChangeable(){
        const spieleIds = Object.keys(this.spiele);
        for ( let i = 0; i < spieleIds.length; i++ ) {
            const spiel = this.spiele[spieleIds[i]];
            if ( spiel.vereine.heim.indexOf('pending') === -1 ||
                 spiel.referee.name ||
                (spiel.heim.result.kegel + spiel.gast.result.kegel) > 0
            ) {
                return false;
            }
        }
        return true;
    }
    getEmptyErsatzspielerObjekt(){
        if ( this.anzahlErsatzSpieler === 0 ) {
            return {
                ['gast.ersatzSpieler']: {},
                ['heim.ersatzSpieler']: {},
            };
        } else {
            let ersatzSpieler = this.eintauschVorEinspielzeit ?
                {
                    id: '', name: '', nationalitaet: '', eintauschVorFuer: '', eintauschFuer: '', abWurf: 0
                } : {
                    id: '', name: '', nationalitaet: '', eintauschFuer: '', abWurf: 0
                };
            if ( this.freieSpieler ) {
                ersatzSpieler.frei = false;
                ersatzSpieler.hatPass = false;
            }
            let ersatzSpielerObjekt = {
                ['gast.ersatzSpieler']: {},
                ['heim.ersatzSpieler']: {},
            }
            for ( let i = 0; i < this.anzahlErsatzSpieler; i++ ) {
                ersatzSpielerObjekt['gast.ersatzSpieler'][i+1] = ersatzSpieler;
                ersatzSpielerObjekt['heim.ersatzSpieler'][i+1] = ersatzSpieler;
            }
            return ersatzSpielerObjekt;
        }

    }


}